/**
 * INT-1691: analytics for the chat's "this message cannot be shown" notices.
 *
 * Measures how many accounts see one each week, by notice and channel (the
 * INT-1647 roadmap metric). Separate from `wapi_error_notice_unmapped`
 * (INT-1500), which only reports Meta codes the catalog does not explain.
 * Names follow `front.<domain>.<entity>.<action>`.
 */
export const UNSUPPORTED_NOTICE_EVENTS = {
  /**
   * A bubble showed a notice for content the chat cannot show. Sent once per
   * message and code while the tab stays open. Carries `code`, `channel_type`,
   * `source` and `message_created_at`.
   */
  SHOWN: 'front.chat.message.unsupported_notice_shown',
} as const;

/**
 * Who decided the content cannot be shown: the backend, through the
 * message's error, or the client, which recognises a Lottie sticker on its
 * own (INT-1708). Lets the query add up or split the two 2005s.
 */
export const UNSUPPORTED_NOTICE_SOURCES = {
  SERVER: 'server',
  CLIENT: 'client',
} as const;

export type tUnsupportedNoticeSource =
  (typeof UNSUPPORTED_NOTICE_SOURCES)[keyof typeof UNSUPPORTED_NOTICE_SOURCES];

/** A notice that counts: its chat code (or error name) and its source. */
export type tUnsupportedNotice = {
  code: string;
  source: tUnsupportedNoticeSource;
};
